// extracted by mini-css-extract-plugin
module.exports = {"frameWrapper":"SideBySideJDP_frameWrapper__Tmsdh","frameWrapper_open":"SideBySideJDP_frameWrapper_open__fNKS9","frame":"SideBySideJDP_frame__r08kN"};